import { useRouter } from 'next/navigation';
import { useConsole } from 'contexts';
import { homeRoutes } from 'data/routes';
import { Button, Flex } from 'ui';

export function Navbar() {
  const { screen } = useConsole();
  const router = useRouter();

  if (screen.isMobile) return null;

  return (
    <Flex justifyContent="center" spacing={1} sx={{ mt: 2 }}>
      {homeRoutes.map(({ icon, label, href }) => (
        <Button
          key={href}
          color="black"
          onClick={() => router.push(href)}
          size="small"
          startIcon={icon}
          rounded
        >
          {label}
        </Button>
      ))}
    </Flex>
  );
}
